import { type IOptionUnwindInfo } from './option-unwind-info'

export const useOptionUnwindDialogStore = defineStore(
  'optionUnwindDialog',
  () => {
    const DEFAULT_DATA: IOptionUnwindInfo = {
      type: 'BUY',
      sniperType: 'uSNIPER',
      address: '',
      strikePrice: '0',
      sniperAmount: '0',
      dobReward: {
        amount: '0',
        usd: '0',
      },
      formattedExerciseTimestamp: (Date.now() / 1000).toString(),
    }
    const {
      value: isDialogVisible,
      setTrue: openDialog,
      setFalse: closeDialog,
    } = useBoolean(false)
    const data = ref<IOptionUnwindInfo>(DEFAULT_DATA)

    const setData = (newData: IOptionUnwindInfo) => {
      data.value = newData
    }

    const reset = () => {
      data.value = DEFAULT_DATA
    }

    return {
      data,
      isDialogVisible,
      openDialog,
      closeDialog,
      setData,
      reset,
    }
  },
)
